// Dependencies
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var _ = require('underscore');
var Backbone = require('backbone');
var format = require('string-format');
var queryString = require('query-string');

// App
var { ListingsLayout } = require('./listings');
var ContactView = require('app/public-app/apps/listing-detail/contact-view');
var ClientFeedbackView = require('app/public-app/apps/common/client-feedback-view');
var ClientFeedback = require('app/public-app/apps/entities').ClientFeedback;
var DetailTpl = require('./templates/detail.html');
var Template = require('app/utils/template');
var Gallery = require('app/common/behaviors/gallery');
var DetailMapView = require('app/react-app/apps/listings/detail/detail-map-view');
var Affix = require('app/common/behaviors/affix');
var initials = require('app/utils/string').initials;

// Channels
var channel = Radio.channel('global');

var DetailView = Marionette.LayoutView.extend({
    className: 'public-listing-detail',
    template: Template(DetailTpl),
    regions: {
        map: '[data-region="map"]',
        listings: '[data-region="listings"]',
        clientFeedback: '[data-region="client-feedback"]',
    },
    ui: {
        viewFloorplans: '[data-ui="viewFloorplans"]',
        contactAgent: '[data-ui="contactAgent"]',
    },
    events: {
        'click @ui.contactAgent': 'contactAgent',
    },
    behaviors: {
        ListingPhotos: {
            behaviorClass: Gallery,
            gallerySelector: '[data-ui="photoGallery"]',
            openGallerySelector: '[data-ui="viewPhotos"]',
            galleryOptions: {
                download: false,
            },
        },
        ListingFloorplans: {
            behaviorClass: Gallery,
            gallerySelector: null,
            openGallerySelector: '[data-ui="viewFloorplans"]',
            galleryOptions: function() {
                return {
                    dynamic: true,
                    dynamicEl: this.getBuildingFloorplans(),
                };
            },
        },
        StickyContacts: {
            behaviorClass: Affix,
            offsetSelector: ['.primary-listing-info', '.footer'],
        },
    },
    onShow: function() {
        this.showMap();
        this.showAvailableListings();
        this.setPageTitle();
        this.setHBCondition();
        this.showClientFeedback();
    },

    setHBCondition: function() {
        if (!window.HB) {
            return;
        }

        window.HB.setCustomConditionValue('city', this.model.get('building').city);
        window.HB.setCustomConditionValue('state', this.model.get('building').state);
        window.HB.setCustomConditionValue('market', this.model.get('company').market);
    },

    setPageTitle: function() {
        var building = this.model.get('building');
        var displayAddress;
        if (building.location_neighborhood_only) {
            displayAddress = building.public_address;
        } else {
            var publicAddress = building.primary_neighborhood
                ? `${building.public_address}, `
                : building.public_address;
            var primaryNeighborhood = building.primary_neighborhood || '';
            displayAddress = `${publicAddress}${primaryNeighborhood}`;
        }

        var buildingName = building.building_name ? `${building.building_name} - ` : '';
        document.title = `${buildingName}${displayAddress}`;
    },

    showClientFeedback: function() {
        var building = this.model.get('building');
        var query = queryString.parse(this.model.get('queryString'));
        var urlArgs = this.getOption('urlArgs');
        // if urlArgs.length is 5, agentId is the 3rd element (not included if length is 4)
        var urlArgs = this.getOption('urlArgs');
        var agentId = urlArgs && urlArgs.length === 5 ? urlArgs[2] : null;

        if (query.client_listing_id) {
            var clientFeedback = new ClientFeedback({
                building_id: building.id,
                client_listing_id: query.client_listing_id,
                agent_id: agentId,
            });
            clientFeedback.fetch().done(
                function() {
                    var clientFeedbackView = new ClientFeedbackView({
                        model: clientFeedback,
                    });
                    this.getRegion('clientFeedback').show(clientFeedbackView);
                }.bind(this)
            );
        }
    },

    showMap: function() {
        var building = this.model.get('building');

        if (building.location) {
            var neighborhoodGeometry = this.model.get('neighborhood_geometry');
            var location = building.location;
            const mapboxAccessToken = channel.request('config:pick', 'MAPBOX_ACCESS_TOKEN');

            this.showChildView(
                'map',
                new DetailMapView({
                    model: this.model,
                    neighborhoodGeometry: neighborhoodGeometry && neighborhoodGeometry.geometry.coordinates[0],
                    showMarker: building.location_address_only,
                    showCircle: building.location_street_only,
                    location: { lng: location[0], lat: location[1] },
                    zoom: building.location_neighborhood_only ? 14 : 16,
                    mapboxAccessToken: mapboxAccessToken,
                    detailBlock: false,
                    enableNeighborhoodGeometry: false,
                })
            );
        }
    },

    showAvailableListings: function() {
        const listingsLayout = new ListingsLayout({
            model: this.model,
            urlArgs: this.getOption('urlArgs'),
        });
        this.listenTo(listingsLayout, 'loaded', function() {
            this.showChildView('listings', listingsLayout);
        });
    },

    onSubmitContactSuccess: function() {
        var contactAgentBtn = this.ui.contactAgent;
        var contactButtonText = contactAgentBtn.text();
        contactAgentBtn
            .addClass('btn-success')
            .attr('disabled', true)
            .text('Email Sent!');

        _.delay(
            _.bind(function() {
                contactAgentBtn
                    .removeClass('btn-success')
                    .removeAttr('disabled')
                    .text(contactButtonText);
            }, this),
            3000
        );
    },

    contactAgent: function(e) {
        e.preventDefault();
        var contacts = new Backbone.Collection(this.model.get('contacts'));

        var contactView = new ContactView({
            contacts: contacts,
            url: format('/p/building/{0}/contact.json', this.getOption('urlArgs').join('/')),
        });

        this.listenTo(contactView, 'submit:success', this.onSubmitContactSuccess);

        contactView.on('destroy', function() {
            this.stopListening(contactView, 'submit:success');
        });

        channel.request('show:modal', contactView, this);
    },

    templateHelpers: function() {
        var contacts = this.model.get('contacts');
        var building = this.model.get('building');

        return {
            amenities: this.model.get('building')['amenities'],
            hasContactEmails: contacts.length
                ? _.every(contacts, function(contact) {
                      return contact.email && !contact.is_company;
                  })
                : false,
            initializeStr: function(str) {
                return initials(str);
            },
            buildingTitle() {
                if (building.location_address_only) {
                    return building.public_building_name;
                } else if (building.location_street_only) {
                    return building.public_street_address;
                }
                return building.neighborhood_name;
            },
            buildingLocationName() {
                if (building.location_address_only) {
                    if (building.building_name) {
                        return building.public_address;
                    }
                }
                return building.primary_neighborhood;
            },
        };
    },
    getBuildingFloorplans: function() {
        return _.map(this.model.get('building').floorplans, function(item) {
            return { thumb: item.thumbnail, src: item.xlarge };
        });
    },
});

module.exports = DetailView;
